import styled, { createGlobalStyle, css } from 'styled-components'
import Form from '@/ui/Form'

// The top of the calendar is hidden by the tabs, so we have to move it down
export const CalendarPositionStyles = createGlobalStyle`
  .react-datetime-picker__calendar {
    top: -220px !important;
  }
`

export const PageWrapper = styled.div`
  padding: 0 1em 1em 1em;
`
export const Container = styled.div`
  &&&& {
    transform-origin: top center;
    background-color: #fff;
    transition: height 300ms ease;
    i {
      cursor: pointer;
      top: -1px;
    }

    i.icon-calendar {
      cursor: pointer;
      top: -3px;
    }
    .field {
      margin: 0;
      label {
        margin-bottom: 0 !important;
      }
    }
  }
`
export const FieldContainer = styled.div<{ width: string }>`
  ${({ width }) => css`
    width: ${width};
    margin-right: 12px;
    position: relative;
    .required-dot {
      display: none;
    }
    .error-message-container {
      position: absolute;
      bottom: -100%;
      background-color: #fff;
      z-index: 100;
      left: 0;
      width: 100%;
    }
  `}
`

export const Toggle = styled(Form.Checkbox)`
  &&& {
    padding-top: 8px;
    .toggle {
      label::before {
        width: 24px;
        height: 16px;
        background-color: #e6e8eb;
      }
      label::after {
        width: 12px;
        height: 12px;
        top: 2px;
        background: #fff;
        border: 0;
        left: 2px;
        box-shadow: none;
      }
      label {
        padding-top: 0;
        padding-left: 36px;
      }
      input:checked ~ label::after {
        box-shadow: none;
        left: 10px;
        transition: all 0s;
      }
    }
  }
`

export const ExtraOptionsContainer = styled.div`
  &&&&& {
    opacity: 1;
    transition: height 1.3s;
    padding: 24px;
    background-color: #f9f9fa;
    border-radius: 4px;
    border: 1px solid #e5eaeb;
    .field {
      margin-right: 16px;
    }
    .react-datetime-picker__button {
      display: flex;
      align-items: center;
    }
    div.field:last-child {
      margin-right: 0;
    }
  }
`

export const UploadDimmer = styled.div`
  background-color: rgba(255, 255, 255, 0.8);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 30vh;
  z-index: 100;
`

interface Props {
  status:
    | 'invalidSize'
    | 'invalidFormat'
    | 'completed'
    | 'uploading'
    | 'unknownError'
}

export const ProcessedFileContainer = styled.div<Props>`
  ${({ status, theme }) => css`
    &&& {
      background-color: ${[
        'invalidSize',
        'invalidFormat',
        'unknownError',
      ].includes(status)
        ? 'rgba(255, 111, 97, 0.05)'
        : status === 'completed'
        ? 'rgba(42, 94, 246, 0.05)'
        : 'rgba(0,0,0,0)'};
      padding: 12px;
      align-items: center;
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;
      border-radius: 6px;
      border: 1px solid
        ${['invalidSize', 'invalidFormat'].includes(status)
          ? theme.colors.red
          : status === 'completed'
          ? '#2A5EF6'
          : theme.colors.darkGrey};

      svg {
        margin-right: 10px;
      }
      .loader {
        margin-right: 10px;
      }
    }
  `}
`
export const FileSize = styled.span`
  ${({ theme }) => css`
    margin-left: 16px;
    color: ${theme.colors.textGrey};
  `}
`
export const StatusContainer = styled.span<Props>`
  ${({ theme, status }) => css`
    &&&& {
      display: flex;
      align-items: center;
      color: ${['invalidSize', 'invalidFormat'].includes(status)
        ? theme.colors.red
        : status === 'completed'
        ? '#2A5EF6'
        : theme.colors.textGrey};

      i {
        margin-left: 10px;
        cursor: pointer;
      }
    }
  `}
`

export const ErrorContainer = styled.div`
  border-bottom: 1px solid #e5eaeb;
  padding-bottom: 32px;
  margin-bottom: 32px;
`
